import React from 'react';
import { useTranslation } from 'react-i18next';

import { CATEGORY_KEY_MAP } from '../../../constants/moderationMappings';
import './_flagged-message-bubble-tags.scss';

type FlagCategory = {
  category: string;
  severity: string;
};

type FlaggedMessageBubbleTagsProps = {
  categories: FlagCategory[];
};

function FlaggedMessageBubbleTags({ categories }: FlaggedMessageBubbleTagsProps): JSX.Element | null {
  const { t } = useTranslation(['chatbot']);

  if (!categories || categories.length === 0) {
    return null;
  }

  return (
    <div className="flagged-message-bubble-tags">
      {categories.map((cat) => {
        const translationKey = CATEGORY_KEY_MAP[cat.category];
        const label = translationKey ? t(`chatbot:${translationKey}`) : cat.category;

        return (
          <span className="flagged-message-bubble-tags__tag" key={cat.category}>
            {label}
          </span>
        );
      })}
    </div>
  );
}

export default FlaggedMessageBubbleTags;
